import { render, staticRenderFns } from "./PopUpDataTableObject.vue?vue&type=template&id=2bc24f82&scoped=true"
import script from "./PopUpDataTableObject.vue?vue&type=script&lang=js"
export * from "./PopUpDataTableObject.vue?vue&type=script&lang=js"
import style0 from "./PopUpDataTableObject.vue?vue&type=style&index=0&id=2bc24f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc24f82",
  null
  
)

export default component.exports